class GiftBox extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
  }

  connectedCallback() {
    this.onInputChange = this.onInputChange.bind(this);
    this.form.addEventListener('change', this.onInputChange)
  }

  disconnectedCallback() {
    this.form.removeEventListener('change', this.onInputChange)
  }

  onInputChange(event) {
    const formData = new FormData(event.target.closest('form'));
    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    cartItems.updateQuantities(null, null, formData);
  }
}

customElements.define('gift-box', GiftBox);